export const DATETIME_INPUT_TIME_PICKER_FORMAT_MAP = {
	hh: Array.from({length: 12}, (_, i) => String(i + 1).padStart(2, '0')),
	h: Array.from({length: 12}, (_, i) => String(i + 1)),
	HH: Array.from({length: 24}, (_, i) => String(i).padStart(2, '0')),
	H: Array.from({length: 24}, (_, i) => String(i)),
	KK: [...Array.from({length: 11}, (_, i) => String(i + 1).padStart(2, '0')), '00'],
	K: [...Array.from({length: 11}, (_, i) => String(i + 1)), '0'],
	kk: ['24', ...Array.from({length: 23}, (_, i) => String(i + 1).padStart(2, '0'))],
	k: ['24', ...Array.from({length: 23}, (_, i) => String(i + 1))],
	mm: Array.from({length: 60}, (_, i) => String(i).padStart(2, '0')),
	m: Array.from({length: 60}, (_, i) => String(i)),
	ss: Array.from({length: 60}, (_, i) => String(i).padStart(2, '0')),
	s: Array.from({length: 60}, (_, i) => String(i))
};